import { render } from "./CourierEstimate.vue?vue&type=template&id=9d4153f6"
import script from "./CourierEstimate.vue?vue&type=script&lang=js"
export * from "./CourierEstimate.vue?vue&type=script&lang=js"

import "./CourierEstimate.vue?vue&type=style&index=0&id=9d4153f6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/CourierEstimate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d4153f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d4153f6', __exports__)) {
    api.reload('9d4153f6', __exports__)
  }
  
  module.hot.accept("./CourierEstimate.vue?vue&type=template&id=9d4153f6", () => {
    api.rerender('9d4153f6', render)
  })

}


export default __exports__